import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";

import { Button } from "nvent-web/components/Button";
import LinkButton from "nvent-web/components/Button/LinkButton";
import { Auth0 } from "nvent-web/services/Auth0";

import { RegistrationFlow } from "../../stores/RegistrationFlow";
import CredentialsForm from "./CredentialsForm";
import style from "./CredentialsStep.module.scss";
import RegistrationHeading from "./RegistrationHeading";

export interface CredentialsStepInnerProps {
  registration: RegistrationFlow;
  auth0: Auth0;
}

export class CredentialsStepInner extends Component<CredentialsStepInnerProps> {
  @observable isLoggingOut = false;

  render() {
    const { registration } = this.props;

    return (
      <div className={style.root}>
        <RegistrationHeading />
        <main className={style.main}>
          <CredentialsForm />
        </main>
        <footer className={style.footer}>
          {registration.isSigningUp ? (
            <>
              <FormattedMessage id="register.login" />
              <LinkButton to="/auth/login" theme="secondaryRed" size="xs" className={style.loginButton}>
                <FormattedMessage id="register.login.action" />
              </LinkButton>
            </>
          ) : (
            <>
              <FormattedMessage id="register.logout" />
              <Button
                onClick={this.logout}
                loading={this.isLoggingOut}
                disabled={this.isLoggingOut}
                theme="secondaryRed"
                size="xs"
                className={style.loginButton}
              >
                <FormattedMessage id="register.logout.action" />
              </Button>
            </>
          )}
        </footer>
      </div>
    );
  }

  private logout = async () => {
    this.isLoggingOut = true;

    try {
      await this.props.auth0.logout();
    } finally {
      this.isLoggingOut = false;
    }
  };
}

export const CredentialsStep = compose<CredentialsStepInnerProps, {}>(
  inject("registration", "auth0"),
  observer
)(CredentialsStepInner);
